import { useEffect } from "react";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!content) { el?.remove(); return; }
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
};
const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) { el = document.createElement("link"); el.rel = rel; document.head.appendChild(el); }
  el.href = href;
};
export const siteUrl = () => (process.env.REACT_APP_SITE_URL || window.location.origin).replace(/\/$/, "");

export const useSeo = ({ title, description, path, noindex = false, jsonLd }) => {
  useEffect(() => {
    document.title = title;
    const url = siteUrl() + (path ?? window.location.pathname);
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:locale", "nb_NO");
    setLink("canonical", url);
    document.getElementById("page-jsonld")?.remove();
    if (jsonLd) {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.id = "page-jsonld";
      s.text = JSON.stringify(jsonLd);
      document.head.appendChild(s);
    }
  }, [title, description, path, noindex, jsonLd]);
};

export const businessLd = (cfg, extra = {}) => ({
  "@context": "https://schema.org", "@type": "HouseCleaningService", name: "Ask-Stokke Renhold", url: siteUrl(),
  telephone: cfg?.phone ? `+47${cfg.phone}` : undefined, email: cfg?.email,
  areaServed: ["Asker", "Bærum", "Sandvika", "Heggedal", "Vollen", "Slemmestad", "Fornebu", "Oslo", "Drammen"],
  ...(cfg?.org_nr ? { taxID: cfg.org_nr } : {}),
  ...(cfg?.visit_address ? { address: { "@type": "PostalAddress", streetAddress: cfg.visit_address, addressCountry: "NO" } } : {}),
  ...extra,
});

// ---- Analytics (GA4, only after consent) ----
let gaLoaded = false;
export const loadGA = (id) => {
  if (gaLoaded || !id || localStorage.getItem("consent") !== "yes") return;
  gaLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", id, { anonymize_ip: true });
};
export const track = (event, params = {}) => { if (window.gtag && gaLoaded) window.gtag("event", event, params); };
